import ReactGA from "react-ga4";

ReactGA.initialize("G-B4M5S8LVN6");

function ga4PageView(path) {
    ReactGA.send({ hitType: "pageview", page: path, });
}

function ga4AddToCart(product, currency, value) {
    ReactGA.event("add_to_cart", {
        currency,
        value,
        items: [
            {
                item_id: product.productId,
                item_name: product.name
            }
        ]
    });
}

function ga4RemoveFromCart(product, currency, value, quantity) {
    ReactGA.event("remove_from_cart", {
        currency,
        value,
        items: [
            {
                item_id: product.productId,
                item_name: product.name,
                quantity
            }
        ]
    });
}

function ga4BeginCheckout(products, currency, value, coupon = null) {
    let items = [];
    products.forEach((product) => {
        items.push({
            item_id: product.productId,
            item_name: product.name,
            quantity: product.quantity,
        });
    });

    ReactGA.event("begin_checkout", {
        currency,
        value,
        items,
        coupon,
    })
}

function ga4PurchaseComplete(products, currency, value, paymentIntent, coupon = null) {
    console.log("***** SENDING TO GA4 *****");
    console.log("Products : ", products);
    console.log("currency : ", currency);
    console.log("value : ", value);
    console.log("paymentIntent : ", paymentIntent);

    let items = [];
    products.forEach((product) => {
        items.push({
            item_id: product.productId,
            item_name: product.name,
            quantity: product.quantity,
        });
    });

    ReactGA.event("purchase", {
        transaction_id: paymentIntent,
        currency,
        value,
        items,
        coupon,
    });

    console.log("**** WINDOW.gtag ****");
    console.log(window.gtag);

    window.gtag('event', 'conversion', {
        send_to: 'AW-17292179868/PQQ4CPTBuuwaEJzzxrVA',
        transaction_id: paymentIntent,
        value,
        currency,
    });

    console.log("**** WINDOW.DATALAYER ****");
    console.log(window.dataLayer);
}

function ga4Login() {
    ReactGA.event("login");
}

function ga4SignUp() {
    ReactGA.event("sign_up");
}

export default {
    ga4PageView,
    ga4AddToCart,
    ga4RemoveFromCart,
    ga4BeginCheckout,
    ga4PurchaseComplete,
    ga4Login,
    ga4SignUp
}